import {
  Component,
  Inject,
  Renderer2,
  ChangeDetectorRef,
  OnInit,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {CommonModule, DOCUMENT, NgFor, NgIf} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {CalendarEvent} from '../flexible-calendar/calendar-event.model';
import {FlexibleCalendarComponent} from '../flexible-calendar/flexible-calendar.component';
import {MatError, MatFormField, MatLabel, MatInputModule} from '@angular/material/input'; // Added MatInputModule
import {DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule, NativeDateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate
} from '@angular/material/datepicker'; // <-- Nouvel import
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {ActivatedRoute, Router} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import packageJson from '../../../package.json';
import {
  alert_message,
  convert_to_find_day,
  string_sorter_for_column,
  export_to_excel,
  string_sorter,
  translate_to_dict, filter_values
} from '../../main';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {MatSlideToggle} from '@angular/material/slide-toggle';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CoursServices} from '../services/cours.services';
import {
  appliname, default_end_time,
  default_event_infobulle,
  default_event_mask, default_start_time, domain_oasis,
  filter_colors,
  filter_filterValue,
  filter_header1,
  filter_header2, show_masks,
  show_sources, toolbar_visibility_for_share
} from '../../env';
import {Tuto} from '../tuto/tuto';


const colorPalette = [
  "RGB(255, 99, 132)", "RGB(54, 162, 235)", "RGB(255, 206, 86)", "RGB(75, 192, 192)",
  "RGB(153, 102, 255)", "RGB(255, 159, 64)", "RGB(255, 0, 0)", "RGB(0, 255, 0)",
  "RGB(0, 255, 255)", "RGB(255, 255, 0)", "RGB(0, 255, 255)", "RGB(255, 0, 255)",
  "RGB(192, 192, 192)", "RGB(128, 128, 128)", "RGB(128, 0, 0)", "RGB(128, 128, 0)",
  "RGB(0, 128, 0)", "RGB(128, 0, 128)", "RGB(0, 128, 128)", "RGB(0, 0, 128)",
  "RGB(72, 61, 139)", "RGB(47, 79, 79)", "RGB(218, 165, 32)", "RGB(34, 139, 34)",
  "RGB(70, 130, 180)", "RGB(210, 105, 30)", "RGB(139, 0, 0)", "RGB(255, 127, 80)",
  "RGB(0, 206, 209)", "RGB(148, 0, 211)", "RGB(255, 20, 147)", "RGB(0, 250, 154)",
  "RGB(240, 230, 140)", "RGB(105, 105, 105)", "RGB(176, 224, 230)", "RGB(255, 228, 181)",
  "RGB(221, 160, 221)", "RGB(144, 238, 144)", "RGB(173, 216, 230)", "RGB(250, 128, 114)"
]

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'dd/MM/yy',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    CommonModule, NgIf, NgFor,
    FlexibleCalendarComponent, MatFormField,
    MatLabel, MatStartDate, MatEndDate,
    FormsModule, MatDatepickerToggle,
    MatNativeDateModule, MatDateRangeInput, MatDateRangePicker, MatError, ReactiveFormsModule,
    MatIconModule, MatButtonModule, MatSelectModule,
    MatInputModule, MatAutocompleteModule, MatMenu, MatMenuItem, MatMenuTrigger, MatProgressSpinner, MatSlideToggle, Tuto, // Added MatInputModule here
  ],
  providers: [
    { provide: DateAdapter, useClass: NativeDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ], // Ajout du service dans les providers
  templateUrl: './main.html',
  styleUrl: './main.css'
})
export class Main implements OnInit  {
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>

  version: string = packageJson.version;
  isMobile=false
  events:CalendarEvent[]=[]
  show_toolbar=true
  columns: string[]=[]
  order_sort="a,s,g,p,j,t,u"

  // Filtering properties
  selectedFilter: any={}

  filteredEvents: CalendarEvent[] = [];
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(new Date(new Date().getFullYear(),0,1,0,0,0)),
    end: new FormControl<Date | null>(new Date(new Date().getFullYear(),11,31,0,0,0)),
  });

  // Theme property
  isDarkTheme: boolean = false;
  filters:any={}
  columnHeaderName: any;
  columnHeaderNames: string[]=[]
  source: any="oasis_homolo"
  subColumnHeaderName: any;
  subColumnHeaderNames: string[]=[]
  share_url: any={}
  ColumnColor: any;
  title=""
  params: any={source:"json"}
  isSidePanelOpen = false;
  limitEventsTo1000 = false;
  increment_periode: string="currentWeek"
  loading_progress=5
  show_hourglass: boolean = false;

  private static _global_load_complete: boolean = false; // Static to track across component instances


  loading_message: string = "";
  ColumnColorValues:string[]=[]

  eventDisplayMask: string = "<g>{Groupe}:{titre}</g><br>{salle} - {Prof}<br><br>{plage}"; // Default mask
  eventDisplayInfoBulle: string = "<g>{Groupe}:{titre}</g><br>{salle} - {Prof}<br><br>{plage}"; // Default mask

  maskSuggestions: string[] = [
    "{titre}",
    "{titre} - {salle}",
    "<g>{titre}</g>-{salle}<br>{plage}",
    "<g>{titre}</g><br>{salle} - {Prof}",
    "<g> {titre}</g><br>{salle} - {Prof}<br><br>Annee : {Annee}"
  ];
  public removeEmptyColumns=false
  private capture: String=""
  private fileContent: any
  protected burger_menu=true

  constructor(
    private route:ActivatedRoute,
    //private calendarService: GoogleCalendar,
    private toast: MatSnackBar,
    private router:Router,
    @Inject(DOCUMENT) private document: Document,
    private oasisService:CoursServices,
    private renderer: Renderer2,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef
  ) {}

    async ngOnInit() {
      setTimeout(()=>{
        this.initWindow()
      },2000)
    }



  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }


  @HostListener('window:maximize', ['$event'])
  onMaximize(event: any) {
    this.checkScreenSize();
  }


  checkScreenSize() {
    this.isMobile = window.innerWidth <= 750;
  }


  async refresh(){
    await this.getUrlParams()
    this.onFilterChange()
    this.onColumnChange()
    this.onColumnColorChange()
  }

  async initWindow(){
    this.checkScreenSize()
    this.filters={}

    await this.load_events_and_init_column_headers(this.source)
    this.update_content_filters_from_events(this.events)
    await this.refresh();

    // First launch tutorial - Color feature explanation
    setTimeout(() => {
      this.initColorTutorial()
    }, 1000)

  }


  /**
   * Initialize the color feature tutorial on first launch
   */
  private initColorTutorial(): void {
    // Check if this is the first launch (no tutorial shown yet)
    const tutorialShown = localStorage.getItem('planner_tutorial_color_shown')
    if (tutorialShown) {
      return // Tutorial already shown
    }

    // Check if ColumnColorValues has options (data is loaded)
    if (!this.ColumnColorValues || this.ColumnColorValues.length === 0) {
      // Retry after a delay if data isn't loaded yet
      setTimeout(() => this.initColorTutorial(), 1000)
      return
    }

    // Mark tutorial as shown
    localStorage.setItem('planner_tutorial_color_shown', 'true')

  }



  private apply_filter_on_events(): void {
    //appllication des filtres from_filters apply_filter
    console.log("Apply filter on events ")

    this.filteredEvents = this.events.filter((event): boolean => {
        if (!this.range.value.start || !this.range.value.end)
          return false

        if (new Date(event.startTime) < this.range.value.start || new Date(event.endTime) > this.range.value.end)
          return false

        for (let prop of this.columnHeaderNames) {
          if (this.selectedFilter[prop] && this.selectedFilter[prop].length > 0) {
            const values=event.props[prop]
            if(!values && prop=="professeurs"){
              return false
            }
            if(values){
              for(let value of values.split(',')){
                if (this.selectedFilter[prop].indexOf(convert_to_find_day(String(value))) == -1)
                  return false
              }
            }
          }
        }
        return true
      }
    )
    if (this.limitEventsTo1000 && this.filteredEvents.length > 3000) {
      this.filteredEvents = this.filteredEvents.slice(0, 3000);
    }

    this.update_url()
  }



  //onChangeFilter

  onFilterChange(): void {
    setTimeout(()=>{
      this.apply_filter_on_events()
      this.onColumnChange()
    },50)
  }




  toggleTheme(): void {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      this.renderer.addClass(this.document.body, 'dark-theme');
    } else {
      this.renderer.removeClass(this.document.body, 'dark-theme');
    }
  }



  update_content_filters_from_events(events:CalendarEvent[]) {
    this.filters={}
    this.startTime=default_start_time
    this.endTime=default_end_time
    console.log("update filter with events")
    for(let rawData of events){
      if(this.range.value.start && this.range.value.end){

        const dtStartTime=new Date(rawData.startTime)
        const dtEndTime=new Date(rawData.endTime)

        if(new Date(rawData.startTime)>=this.range.value.start && dtEndTime<=this.range.value.end){
          if(dtStartTime.getHours()<this.startTime && dtStartTime>new Date()){
            this.startTime=dtStartTime.getHours()
          }
          if(dtEndTime.getHours()>this.endTime)this.endTime=dtEndTime.getHours()


          for(let prop of this.columnHeaderNames){
            this.filters[prop]=this.filters[prop] || []
            if(convert_to_find_day(rawData.props[prop]) && !this.filters[prop].includes(convert_to_find_day(rawData.props[prop]))){
              for(let item of convert_to_find_day(rawData.props[prop]).split(",")) {
                if(item!="" && this.filters[prop].indexOf(item)==-1)
                  this.filters[prop].push(item)
              }
            }
          }
        }
      }
    }


    this.columnHeaderNames=string_sorter(this.columnHeaderNames,this.order_sort)

    for(let prop of this.columnHeaderNames){
      this.filters[prop]=string_sorter_for_column(this.filters[prop])
    }

  }


  complete_properties(calEvent:CalendarEvent) : CalendarEvent {
    if(calEvent.startTime){
      const l_day=["#0","#1","#2","#3","#4","#5","#6","#7"]
      const idx=calEvent.startTime.getDay()
      calEvent.props["Jour"] = l_day[idx]
      calEvent.props["Jour du mois"]=calEvent.startTime.getDate().toFixed(0)
      if(calEvent.props["Jour du mois"].length==1)calEvent.props["Jour du mois"]="0"+calEvent.props["Jour du mois"]

      calEvent.props["Jour avec date"]=calEvent.props["Jour du mois"]+" "+l_day[idx]
    }
    return calEvent
  }


  convert_rawData(rawData:any) : CalendarEvent {
    rawData.props["Salle"]=rawData.salle
    //rawData.props["Duree"]=(new Date(rawData.plage.dtEnd).getTime()-new Date(rawData.plage.dtStart).getTime())/(3600*1000)

    const calEvent:CalendarEvent = new CalendarEvent(
      rawData.titre,
      new Date(rawData.plage.dtStart),
      new Date(rawData.plage.dtEnd),
      rawData.salle,
      "",
      rawData.props,
      "color:white;background-color:black;color:white;"
    )
    return this.complete_properties(calEvent)
  }


  init_from_json(data:any[]){
    let events: CalendarEvent[] = []
    for(let rawData of data){
      try{
        const calEvent=this.convert_rawData(rawData)
        if(calEvent.startTime.getDay()<6){
          events.push(calEvent)
        }else{
          console.log("Exclusion des weekend")
        }
      } catch (e){
        console.log("Erreur d'importation "+JSON.stringify(rawData))
      }
    }
    return events
  }


  async import_from_server() : Promise<CalendarEvent[]> {
    return new Promise<CalendarEvent[]>((resolve, reject) => {
      this.http.get<any[]>('/planning_output.json').subscribe({
        next: (data) => {
          resolve(this.init_from_json(data))
        },
        error: (err) => reject(err)
      })
    })
  }


  convert_google_calendar_event(gEvent: any): CalendarEvent {
    const props: any = {};
    const startDate = gEvent.start.dateTime ? new Date(gEvent.start.dateTime) : new Date(gEvent.start.date);
    const endDate = gEvent.end.dateTime ? new Date(gEvent.end.dateTime) : new Date(gEvent.end.date);

    props["Organisateur"] = gEvent.organizer?.displayName || gEvent.organizer?.email || '';
    props["Salle"] = gEvent.location || '';

    const calEvent = new CalendarEvent(
      gEvent.summary || 'Sans titre',
      startDate,
      endDate,
      gEvent.location || '',
      "",
      props,
      "color:white;background-color:green;" // Default style for Google events
    );

    return this.complete_properties(calEvent);
  }



  async import_from_oasis(prod=true,limit=5000,batchCount=5): Promise<CalendarEvent[]> {
    //voir https://test.ensad.oasispro.fr/testapi/v1/doc#/Cours/Oasis%5CEnsad%5COverride%5CApi%5CREST%5CData%5CController%5CCourse%5CCourseCtrl%3A%3Alist
    this.show_hourglass=true
    this.loading_message="Chargement des professeurs ..."

    let events: CalendarEvent[] = [];

    this.oasisService.homolo=!prod

    try{
      const type_cours=(await firstValueFrom(this.oasisService.getTypeCours()))

      this.loading_progress=5
      this.loading_message=`Chargement des séances ...`
      let programs:any[]=[]
      for(let i=0;i<limit;i=i+limit/batchCount){
        const lp=(await firstValueFrom(this.oasisService.getPrograms(i,limit/batchCount))).data
        for(let p of lp){
          programs.push(p)
        }
        this.loading_progress=5+Math.round((i/limit)*60)
        this.cdRef.detectChanges();
      }

      this.loading_message=`Chargement des cours ...`
      let courses:any[]=[]

      for(let i=0;i<4;i++){
        const lc:any[]=(await firstValueFrom(this.oasisService.getCourses(i*100,300))).data
        this.loading_progress=60+Math.round(i*5)
        this.cdRef.detectChanges();
        for(let c of lc){
          courses.push(c)
        }
      }
      courses=translate_to_dict(courses,"code")

      const profs=await firstValueFrom(this.oasisService.getProfs());

      this.removeStartScreen()

      const secteurs=await firstValueFrom(this.oasisService.getSecteurs());
      //const cours_secteurs=await firstValueFrom(this.oasisService.getCoursSecteur());

      this.loading_message="Traitement des evenements..."

      for(let p of programs){
        if(p.sessions.length>0){
          let session=p.sessions[0]

          //recherche du cours correspondant à la programmation
          //Identification du code du cours attaché

          //const module_code=course.list_of_module_codes[0].split(".")
          const codes=p.course.split(".")
          let course=courses[p.course]

          //if(!secteurs.hasOwnProperty(group))console.log("secteur inconnu "+group)

          if(course){
            const calEvent = this.complete_properties(new CalendarEvent(
              course.fr_title,
              new Date(p.date+" "+p.time_start),
              new Date(p.date+" "+p.time_end),
              session.room_code,
              p.program_title,
              p.code,
              {
                semestre:codes[0],
                cours:p.title,
                salle:session.room_code,
                secteur: secteurs.hasOwnProperty(codes[1]) ? secteurs[codes[1]].Titre : codes[1],
                annee:["L1","L1","L2","L2","L3","L3","M1","M1","M2","M2",][Number(codes[0].replace("S",""))],
                professeurs:"",
                code:p.course,
                "type":type_cours[course.course_type]["Type de cours"] || ""
              },
              "color:white;background-color:green;" // Default style for Google events
            ))
            calEvent.props["secteur"]=calEvent.props["secteur"] ? calEvent.props["secteur"].split(" | ")[0] : ""
            calEvent.tags["cours"]=p.course

            if(p.time_start!=""){
              let prof_course=[]
              for(let program of session.profs){
                prof_course.push(program)
              }
              for(let p of profs.elements){
                if(prof_course.indexOf(p.login)>-1 && calEvent.props.professeurs.indexOf(p.prenom_usuel+" "+p.nom_usuel)==-1){
                  calEvent.props.professeurs=calEvent.props.professeurs+p.prenom_usuel+" "+p.nom_usuel+","
                  calEvent.tags["code_prof"]=p.login
                }
              }
              if(calEvent.props.professeurs!="")calEvent.props.professeurs=calEvent.props.professeurs.substring(0,calEvent.props.professeurs.length-1)
              events.push(calEvent)
              if(events.length==limit)break;
            }
          }


        } else {
          console.log("Rejeté par absence de session")
        }
      }

    }catch (e:any){
      this.toast.open("Impossible de charger la source","ok")
      console.log(e)
    }


    this.removeStartScreen()

    return events;
  }





  // async import_from_google_calendar(): Promise<CalendarEvent[]> {
  //   const timeMin = this.range.value.start ? this.range.value.start.toISOString() : undefined;
  //   const timeMax = this.range.value.end ? this.range.value.end.toISOString() : undefined;
  //
  //   const calendarId = await this.calendarService.getPrimaryCalendarId();
  //
  //   const response = await (window as any).gapi.client.calendar.events.list({
  //     'calendarId': calendarId,
  //     'timeMin': timeMin,
  //     'timeMax': timeMax,
  //     'showDeleted': false,
  //     'singleEvents': true,
  //     'maxResults': 2500,
  //     'orderBy': 'startTime'
  //   });
  //
  //   const events: CalendarEvent[] = response.result.items.map((gEvent: any) => this.convert_google_calendar_event(gEvent));
  //   return events;
  // }




  //Récupére les parametres de l'url
  async getUrlParams(onlySource=false): Promise<any> {
    const p:any = await firstValueFrom(this.route.queryParams);
    let params=p
    if(p.hasOwnProperty("param")){
      const jsonString = atob(p["param"].replace(/ /g, '+'))
      params=JSON.parse(jsonString)
    }

    this.source = params['source'] || "oasis"
    this.removeEmptyColumns=(params["condensed"]=='true')
    this.burger_menu=params.hasOwnProperty("burger") ? params["burger"] : true

    if(!onlySource){
      if (params['periode']) {
        const [start, end] = params['periode'].split(',');
        if (start && end) {
          this.range.setValue({ start: new Date(Number(start)),end:  new Date(Number(end)) });
        }
      } else {
        this.onPeriodSelect("currentWeek")
      }

      this.increment_periode = params['increment_periode'] || "semaine"
      if(params.hasOwnProperty("order"))this.order_sort=params["order"]
      if(this.columnHeaderNames.length>2){
        this.columnHeaderName = params['column_header_name'] || filter_values(this.columnHeaderNames,filter_header1)[0]
        this.subColumnHeaderName = params.hasOwnProperty("sub_column_header_name") ? params['sub_column_header_name'] : filter_values(this.columnHeaderNames,filter_header2)[0]
      }
      this.ColumnColorValues=filter_values(this.columnHeaderNames,filter_colors)
      this.ColumnColor = params.hasOwnProperty("color_column") ? params['color_column'] : this.ColumnColorValues[0]

      this.show_toolbar = params['show_toolbar'] ? (params['show_toolbar']=="true") : true
      this.eventDisplayMask = params['event_display_mask'] || default_event_mask
      this.eventDisplayInfoBulle = params['event_display_infobulle'] || default_event_infobulle

      for (let key of Object.keys(params)) {
        if (key.startsWith("f_")) {
          this.selectedFilter[key.substring(2)] = params[key].split(',');
        }
      }
      console.log("Paramètres ",params)
    }

    return params;
  }



  removeStartScreen(){
    this.show_hourglass=false
    this.loading_progress=0
    this.loading_message=""
    this.cdRef.detectChanges();
  }


  async load_events_and_init_column_headers(source="oasis_homolo") {
    if(source.toLowerCase().endsWith("json")){
      this.events=await this.import_from_server()
      this.loading_progress=0;
    }
    //if(source.toLowerCase()=="calendar") this.events = await this.import_from_google_calendar()
    if(source.toLowerCase()=="oasis_homolo") {
      this.events=await this.import_from_oasis(false)
    }
    if(source.toLowerCase()=="oasis") {
      this.events=await this.import_from_oasis(true)
    }

    this.removeStartScreen()
    this.columnHeaderNames=this.events.length>0 ? string_sorter_for_column(Object.keys(this.events[0].props)) : []
    this.subColumnHeaderNames=this.columnHeaderNames
  }




  changePeriod(sens: number, event?: any) {
    const skipToNonEmpty = event?.ctrlKey;
    const maxIterations = 12;
    let iterations = 0;

    do {
      let newStart:Date=new Date()
      let newEnd=newStart
      if(this.range.value.start && this.range.value.end) {
        let current_month = this.range.value.start.getMonth()
        let current_year = this.range.value.start.getFullYear()

        if (this.increment_periode == "current") {
          if (sens == -1) {

            if (this.increment_periode == "current") {
              const start = this.range.value.start;
              const end = this.range.value.end;
              if (start && end) {
                const duration = end.getTime() - start.getTime();
                const shift = duration + (24 * 60 * 60 * 1000);

                newStart = new Date(start.getTime() - shift);
                newEnd = new Date(end.getTime() - shift);
              }
            }
          } else {
            const duration = this.range.value.end.getTime() - this.range.value.start.getTime();
            const shift = duration + (24 * 60 * 60 * 1000);

            newStart = new Date(this.range.value.start.getTime() + shift);
            newEnd = new Date(this.range.value.end.getTime() + shift);
          }
        }

        if (this.increment_periode == "mois") {
          current_month = current_month + sens
          if (current_month == 13) {
            current_month = 1;
            current_year = current_year + 1
          }

          if (current_month == 0) {
            current_month = 12;
            current_year = current_year - 1
          }

          newStart = new Date(current_year, current_month, 1)
          newEnd = new Date(new Date(current_year, current_month + 1, 1).getTime() - 3600 * 24)
        }

        if (this.increment_periode == "année") {
          current_year = current_year + sens
          newStart = new Date(current_year, current_month, 1)
          newEnd = new Date(current_year, 12, 31)
        }

        if (this.increment_periode == "jour") {
          newStart = new Date(this.range.value.start.getTime()+3600*1000*24*sens)
          newEnd= new Date(newStart.getTime()+3600*1000*24)
        }


        if (this.increment_periode == "semaine") {
          newStart=new Date(this.range.value.start.getTime()+3600*24*1000*sens)
          while(newStart.getDay()!=1){
            newStart=new Date(newStart.getTime()+3600*24*1000*sens)
          }
          newEnd=new Date(newStart.getTime()+6*3600*24*1000)
        }


        this.range.setValue({start: newStart, end: newEnd});
        this.onPeriodeChange();
      }
      iterations++;
    } while (skipToNonEmpty && this.filteredEvents.length === 0 && iterations < maxIterations);
  }



  onPeriodeChange() {
    this.apply_filter_on_events()
    this.update_url()
    this.title="Planning du "+this.range.value.start!.toLocaleDateString('fr-FR', { timeZone: 'UTC'})
      +" au "+ this.range.value.end!.toLocaleDateString('fr-FR', { timeZone: 'UTC'})
    this.onColumnChange()
    this.update_content_filters_from_events(this.events)
  }




  update_url() {
    let queryParams: any = {
      condensed:this.removeEmptyColumns,
      source: this.source,
      periode: `${this.range.value.start?.getTime()},${this.range.value.end?.getTime()}`,
      increment_periode: this.increment_periode,
      column_header_name: this.columnHeaderName,
      sub_column_header_name: this.subColumnHeaderName,
      color_column: this.ColumnColor,
      show_toolbar: this.show_toolbar,
      event_display_mask: this.eventDisplayMask,
    };

    // Ajout des filtres dynamiques
    for (let filter_name in this.selectedFilter) {
      if (this.selectedFilter[filter_name]?.length > 0) {
        queryParams["f_"+filter_name] = this.selectedFilter[filter_name].join(",");
      }
    }

    // Mise à jour de l'URL réelle dans le navigateur sans recharger le composant
    this.router.navigate(['/main'], {
      queryParams: queryParams,
      replaceUrl: true // Évite d'empiler l'historique à chaque clic de filtre
    });

    // Pour le bouton de partage, on récupère l'URL complète
    this.share_url =Object.fromEntries(new URLSearchParams( window.location.href.split('?')[1]).entries())

  }



  onColumnChange(new_column:string | null=null) {
    if(new_column){
      this.selectedFilter[new_column]=[]
      this.onFilterChange()
    }

    this.update_url()

    let columns: any[]=[]
    let l1=this.filters[this.columnHeaderName]
    let l2=this.filters[this.subColumnHeaderName]

    this.filters["Jour"]=["Lu","Ma","Me","Je","Ve"]

    if(!l2 || l2.length==0){
      columns=l1
    }else{
      for(let it1 of l1){
        for(let it2 of l2){
          columns.push(it1 + "-" + it2)
        }
      }
    }

    this.columns=[...new Set(columns)]
    if(this.removeEmptyColumns)this.remove_columns()
    this.apply_filter_on_events()
  }


  share() {
    this.share_url["show_toolbar"]=toolbar_visibility_for_share
    let url=window.location.protocol+"/#/main?param="+btoa(JSON.stringify(this.share_url));
    if (navigator.share) {
      navigator.share({
        title: 'Planner View',
        url: url,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
        .catch(console.error);
    } else {
      navigator.clipboard.writeText(url).then(r => alert_message(this,"lien copié dans le presse papier"));
    }
  }



  copy_calendar() {
    const parts = this.capture.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const rawBase64 = parts[1];

    // 2. Décoder le base64 en binaire
    const byteCharacters = atob(rawBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // 3. Créer le Blob
    const blob = new Blob([byteArray], { type: contentType });

    const item = new ClipboardItem({ 'image/png': blob });
    navigator.clipboard.write([item]).then(() => {
      alert_message(this,"Image copiée dans le presse-papier !");
    }).catch(err => {
      console.error("Erreur lors de la copie : ", err);
      alert_message(this,"Impossible de copier l'image.");
    });
  }

  print(): void {
    if (!this.capture) {
      alert_message(this, "Aucune capture disponible pour l'impression.");
      return;
    }

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      let legendHtml = '';
      if (this.ColumnColor && this.filters[this.ColumnColor]) {
        legendHtml = `<div>${this.ColumnColor}</div><div style="font-size:8px; display: flex; flex-wrap: wrap; font-family: sans-serif;">`;

        this.filters[this.ColumnColor].forEach((filter: string, index: number) => {
          const color = colorPalette[index % colorPalette.length];
          legendHtml += `
          <div style="display: flex; align-items: center; margin: 5px;">
            <div style="width: 15px; height: 15px; background-color: ${color} !important; margin-right: 2px; -webkit-print-color-adjust: exact; print-color-adjust: exact;"></div>
            <span>${filter}</span>
          </div>
        `;
        });
        legendHtml += '</div>';
      }

      printWindow.document.write(`
      <html>
        <head>
          <title>Impression Planning</title>
          <style>
            body { margin: 0; padding: 10px; font-family: sans-serif; }
            img { max-width: 100%; height: auto; }

            /* Crucial pour forcer l'impression des couleurs */
            * {
              -webkit-print-color-adjust: exact !important;   /* Chrome, Safari, Edge */
              print-color-adjust: exact !important;           /* Firefox */
              color-adjust: exact !important;                 /* Standard */
            }

            @media print {
              @page { margin: 1cm; }
              body { margin: 0; }
            }
          </style>
        </head>
        <body onload="setTimeout(() => { window.print(); window.close(); }, 500);">
          <h2>Planning du ${this.range.value.start!.toLocaleDateString('fr-FR', { timeZone: 'UTC' })} au ${this.range.value.end!.toLocaleDateString('fr-FR', { timeZone: 'UTC' })}</h2>
          <img src="${this.capture}" />
          <div style="display: flex; flex-wrap: wrap; margin-top: 20px; width: 100%;">
            ${legendHtml}
          </div>
        </body>
      </html>
    `);
      printWindow.document.close();
    }
  }

  onColumnColorChange() {
    this.set_color_of_event()
    this.update_url()
  }

  private set_color_of_event() {
    for(let event of this.events){
      let color="black"
      if(this.ColumnColor && this.filters[this.ColumnColor] && event.props[this.ColumnColor]){
        const idx=this.filters[this.ColumnColor].indexOf(convert_to_find_day(event.props[this.ColumnColor]))
        if(idx!=-1 && colorPalette[idx]) color=colorPalette[idx]
      }
      let r="background-color:"+color+";"
      if(color=="black"){
        r=r+"color:white;"
      }else{
        r=r+"color:black;"
      }
      event.style=r
    }

  }



  onPeriodSelect(period: string) {
    const today = new Date();
    const currentDay = today.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let start: Date;
    let end: Date;

    switch (period) {
      case 'currentDay':
        start = new Date(currentYear,currentMonth,today.getDate(),0,0);
        end = new Date(currentYear,currentMonth,today.getDate()+1,0,0);
        this.increment_periode="jour"
        break;

      case 'currentYear':
        start = new Date(currentYear, 0, 1);
        end = new Date(currentYear, 11, 31);
        this.increment_periode="année"
        break;
      case 'currentScholarYear':
        start = new Date(currentYear, 9, 1);
        end = new Date(currentYear+1, 7, 10);
        this.increment_periode="année"
        break;
      case 'currentMonth':
        start = new Date(currentYear, currentMonth, 1);
        end = new Date(currentYear, currentMonth + 1, 0);
        this.increment_periode="mois"
        break;
      case 'currentWeek':
        const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // Adjust to Monday of the current week
        start = new Date(today.getFullYear(), today.getMonth(), diff);
        end = new Date(today.getFullYear(), today.getMonth(), diff + 6);
        this.increment_periode="semaine"
        break;
      default:
        return;
    }

    // Set hours to cover the full day
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    this.range.setValue({ start, end });
    this.onPeriodeChange();
  }


  cancel_filter(prop: string) {
    this.selectedFilter[prop]=[]
    this.onFilterChange()
    this.cdRef.detectChanges()
  }


  get_color_filter(value:string,prop: string) {
    if(this.ColumnColor==prop){
      return colorPalette[this.filters[prop].indexOf(value)]
    } else {
      return "transparent"
    }
  }

  clear_sub_header(evt:any) {
    evt.stopPropagation()
    this.subColumnHeaderName=""
    this.onColumnChange()
  }

  clear_color(evt:any) {
    evt.stopPropagation()
    this.ColumnColor=""
    this.onColumnChange()
    this.set_color_of_event()
  }

  fire_open(evt: any) {
      this.context_menu({event:evt.event,action:"seance"})
  }



  remove_from_filter($event: String) {
    if (!this.columnHeaderName) return;
    if (!this.selectedFilter[this.columnHeaderName] || this.selectedFilter[this.columnHeaderName].length==0){
      this.selectedFilter[this.columnHeaderName]=this.filters[this.columnHeaderName] || []
    }

    if(this.selectedFilter[this.columnHeaderName] && this.selectedFilter[this.columnHeaderName].length>0){
      if(this.selectedFilter[this.columnHeaderName].indexOf($event)==-1) {
        this.selectedFilter[this.columnHeaderName].push($event)
      }else{
        this.selectedFilter[this.columnHeaderName]=this.selectedFilter[this.columnHeaderName].filter((x:string)=> x!==$event)
      }

      this.onFilterChange()
    }
  }


  toggleSidePanel() {
    this.isSidePanelOpen = !this.isSidePanelOpen;
    this.cdRef.detectChanges();
  }

  onLimitEventsChange(limit: boolean) {
    this.limitEventsTo1000 = limit;
    this.apply_filter_on_events();
  }

  protected readonly colorPalette = colorPalette;


  onSourceChange() {
    if (this.source === 'upload') {
      this.fileUpload.nativeElement.click();
    } else {
      window.location.href = "/main?source=" + this.source;
    }
  }



  handleFileInput(files: FileList | null) {
    if (files && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.fileContent = e.target!.result;
        this.events=this.init_from_json(JSON.parse(this.fileContent))
        this.update_content_filters_from_events(this.events)
        await this.refresh()
      };
      reader.readAsText(file);
    }
  }



  eventsByColumn() {
    const rc:any={}
    if(this.filters[this.columnHeaderName]){
      for(let val of this.filters[this.columnHeaderName]){
        rc[val]=0
      }
      for(let evt of this.filteredEvents){
        const col=convert_to_find_day(evt.props[this.columnHeaderName])
        if(col && this.filters[this.columnHeaderName].indexOf(col)>-1)
          rc[col]=rc[col]+1
      }
    }
    return rc
  }




  isEmptyColumn(){
    let rc=this.eventsByColumn()
    for(let k in rc){
      if(rc[k]==0)return true
    }
    return false
  }



  remove_columns() {
    const rc=this.eventsByColumn()
    let c=[]
    for(let k in rc){
      if(rc[k]>0){
        if(!this.subColumnHeaderName){
          c.push(k)
        }else{
          for(let v of this.filters[this.subColumnHeaderName]){
            c.push(k+"-"+v)
          }
        }

      }
    }
    console.log('[DEBUG remove_columns] columns before filter:', JSON.stringify(c));
    this.columns=c
    console.log('[DEBUG remove_columns] columns after filter:', JSON.stringify(this.columns));
  }


  protected readonly dispatchEvent = dispatchEvent;

  open_legende(evt:any) {
    evt.stopPropagation()
  }

  protected update_capture($event: String) {
    this.capture=$event
  }

  protected readonly alert_message = alert_message;
  protected endTime: number=default_end_time
  protected startTime: number=default_start_time


  exportToExcel() {
    try {
      export_to_excel(this.filteredEvents, this.startTime, this.endTime, this.columnHeaderNames);
    } catch (e) {
      console.error("Erreur lors de l'export Excel:", e);
      this.toast.open("Erreur lors de l'export Excel","ok");
    }
  }


  private async upload(): Promise<CalendarEvent[]> {
    return new Promise<CalendarEvent[]>((resolve, reject) => {
      if (this.fileContent) {
        try {
          const data = JSON.parse(this.fileContent as string);
          let events: CalendarEvent[] = [];
          for (let rawData of data) {
            try {
              const calEvent = this.convert_rawData(rawData);
              if (calEvent.startTime.getDay() < 6) {
                events.push(calEvent);
              } else {
                console.log("Exclusion des weekend");
              }
            } catch (e) {
              console.log("Erreur d'importation " + JSON.stringify(rawData));
            }
          }
          resolve(events);
        } catch (e) {
          console.error("Erreur lors de l'analyse du fichier JSON :", e);
          reject(e);
        }
      } else {
        resolve([]);
      }
    });
  }




  protected readonly filter_filterValue = filter_filterValue;
  protected readonly toolbar_visibility_for_share = toolbar_visibility_for_share;
  protected readonly filter_header1 = filter_header1;
  protected readonly filter_header2 = filter_header2;
  protected readonly filter_values = filter_values;
  protected readonly show_sources = show_sources;



  protected context_menu(evt: { event: CalendarEvent; action: string }) {
    let url="code="+evt.event.code_seance.toString()+"&num=1&type=DETAIL&name=SESSION&YEAR=2026"
    if(evt.action=="cours"){
      url="code="+evt.event.tags.cours+"&type=DETAIL&name=COURSE&tab_COURSE1=COURSEemploi-du-temps-et-emargement"
    }
    if(evt.action=="salle"){
      if(evt.event.salle==""){
        this.toast.open("Pas de salle renseignée","Ok")
        return
      }
      url="code="+evt.event.salle+"&type=DETAIL&name=ROOM&num=3"
    }
    if(evt.action=="professeur"){
      url="code="+evt.event.tags.code_prof+"&num=10&type=DETAIL&name=CONTRACTOR&POSITION_TYPE=CONTRACTOR&tab_CONTRACTOR1=CONTRACTORemploi-du-temps&view=timeGridWeek&date=2026-07-06"
    }
    if(evt.action.startsWith("filtrer")){
      if(evt.action.indexOf("secteur")>-1)this.selectedFilter["secteur"]=[evt.event.props["secteur"]]
      if(evt.action.indexOf("salle")>-1)this.selectedFilter["salle"]=[evt.event.props["salle"]]
      this.apply_filter_on_events()
      return
    }

    if(evt.action!="fermer")window.open(domain_oasis+"/#?"+url,"context")
  }

  protected readonly appliname = appliname;
  protected readonly show_masks = show_masks;


  protected open_help() {
    if(this.events.length==0)  this.changePeriod(1,{ctrlKey:true})
  }

  protected clearFilters() {
    for(let k in this.selectedFilter){
      this.selectedFilter[k]=[]
    }
    this.apply_filter_on_events()
  }

  protected readonly JSON = JSON;
  protected readonly default_start_time = default_start_time;
}
